const formatPrice = (x, currency) => {
	console.log("formatPrice currency=", currency);
	console.log("formatPrice x=", x);
	switch (currency) {
		case "BRL":
			return x.toFixed(2).replace(".", ",");
		case "RWF":
			return x.toFixed(2).replace(".", ",");
		default:
			return x.toFixed(2);
	}
};

export default {
	formatPrice,
};
